import qs from 'qs';
import { getLastFewMinutes } from '../ts/utils';

const baseUrl = process.env.EPAPER_BASE_URL;

/**
 * 根据日期获取全部版面
 * @param date
 * @returns
 */
export const fetchDatePage = async (date: string): Promise<Epaper.Date> => {
  const res = await fetch(
    `${baseUrl}/pc/wxapp/paperJson/${date}/${date}.json?t=${getLastFewMinutes(30)}`,
  );
  return res.json();
};

/**
 * 根据日期、版面号获取版面信息
 * @param date
 * @param page
 * @returns
 */
export const fetchPage = async (
  date: string,
  page: string,
): Promise<Epaper.PageJson> => {
  const res = await fetch(
    `${baseUrl}/pc/wxapp/paperJson/${date}/bc_${page}.json?t=${getLastFewMinutes(30)}`,
  );
  return res.json();
};

/**
 * 根据日期、稿件id获取稿件详情
 * @param date
 * @param article
 * @returns
 */
export const fetchContent = async (
  date: string,
  article: string,
): Promise<Epaper.Article> => {
  const res = await fetch(
    `${baseUrl}/pc/wxapp/paperJson/${date}/${article}?t=${getLastFewMinutes(30)}`,
  );
  return res.json();
};

/**
 * 获取微信分享信息
 * @returns
 */
export const fetchWxConfig = async () => {
  const url = window.location.href.split('#')[0];
  const res = await fetch(
    `https://huacheng.gz-cmc.com/auxiliaryapi/api/content/wxShare/wechatParam?${qs.stringify(
      {
        url,
      },
    )}`,
  );
  return res.json();
};
